import { render, staticRenderFns } from "./SchemaToForm.vue?vue&type=template&id=58a2e796&"
import script from "./SchemaToForm.vue?vue&type=script&lang=js&"
export * from "./SchemaToForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports